import axios from '@axios'

const route = 'register/company'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, { itemsPerPage, page, search }) {
      return axios.get(`${route}?page=${page}&items_per_page=${itemsPerPage}&search=${search}`)
    },
    store(context, role) {
      return axios.post(route, role)
    },
    update(context, role) {
      return axios.put(`${route}/${role.id}`, role)
    },
    updateCompany() {
      return axios.get(`${route}/update_company`)
    },
    getCompanyCredit(context, companyId) {
      return axios.get(`helper/get_company_credit/${companyId}`)
    },
    delete(context, role) {
      return axios.delete(`${route}/${role.id}`)
    },
    getBookingEngineUser(context, companyId) {
      return axios.get(`${route}/${companyId}/booking-engine-user`)
    },
    saveBookingEngineEmail(context, { companyId, email }) {
      return axios.post(`${route}/${companyId}/booking-engine-user`, { email }, { headers: { callbackerror: 1 } })
    },
    toggleBookingEngine(context, { companyId, email = null }) {
      return axios.patch(`${route}/${companyId}/booking-engine-user/toggle`, { email }, { headers: { callbackerror: 1 } })
    },
    resendBookingEnginePassword(context, companyId) {
      return axios.post(`${route}/${companyId}/booking-engine-user/resend-password`, {}, { headers: { callbackerror: 1 } })
    },
  },
}
